import { render, staticRenderFns } from "./preparationverso.vue?vue&type=template&id=4bff7743&lang=html&"
import script from "./preparationverso.vue?vue&type=script&lang=js&"
export * from "./preparationverso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports